import React from 'react';
import { Container } from 'reactstrap';
import { get } from 'lodash-es';

import Step1 from './RealizedPrices/RealizedPrices';
import Step2 from './RealizedPrices/RealizedPricesPreUpload';

const RealizePriceContainer = props => {
  let step = parseInt(get(props, 'match.params.step', 1), 10);
  const title = 'Edit Realized Prices';

  if (step <= 0 || step >= 7) {
    step = 1;
  }
  document.title = 'InvaluableAuctions - '.concat(title);

  return (
    <Container className="py-4">
      <h1 className="pt-4">
        {title}
      </h1>

      {step === 2 ? <Step2 /> : <Step1 />}
    </Container>
  );
};

export default RealizePriceContainer;
